module.exports = "/next-static/_next/static/images/block_image_two-f81de0b9161de0c3e2186c01c1ef6a74.png";